
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { VMoney } from "v-money";
import "air-datepicker/dist/css/datepicker.min.css";

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {},
  computed: {},
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      return value.toUpperCase();
    },
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
  },
  watch: {},
  directives: { money: VMoney },
})
export default class FillClaimData extends Vue {
  title: string = "Declarar Siniestro";
  coinsurance_companies: any = [];
  data: any = {
    newClaim: {
      insurance_number: "",
      claim_date: "",
      status_client: "",
      claim_currency: "",
      estimated_loss_amount: "",
      estimated_expenses: "",
      reserve_indemnization: "",
      reserve_expenses: "",
      permit_reclaim: 1,
      notes: "",
    },
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: true,
    },
  };
  request: any = {
    currency: {
      title: "",
    },
    requests_details: [
      {
        assignmentValidityAonFrom: "",
        assignmentValidityAonTo: "",
        assignment_percent_aon: "",
      },
    ],
  };
  statuses: any = [];
  currencies: any = [];

  async mounted() {
    await this.loadStatuses();
    const request: any = await (this
      .$root as any)._post(
      `requests/one/${this.$store.state.newClaim.request}`,
      { models: "currencies" }
    );
    this.request = request.data[0];

    let _this = this;
    (this as any).$root.localizeDatepicker($);
    let datepicker = $("#claim_date")
      .datepicker({
        language: "es",
        autoClose: true,
        onSelect: function onSelect(fd, date) {
          _this.data.newClaim.claim_date = moment(date).format("DD/MM/YYYY");
        },
      })
      .data("datepicker");
    await this.loadCurrencies();
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadCurrencies() {
    let subscriptorId = this.$store.state.user.id;
    const subscriptor: any = await (this
      .$root as any)._post(`subscriptors/one/${subscriptorId}`, {
      models: "companies",
    });
    const company = subscriptor.data[0].companies[0];

    const response: any = await (this.$root as any)._get(
      `companiescurrencies/bycompany/${company.id}`
    );
    response.data.forEach((c) => {
      if (c.can_do_request) {
        this.currencies.push({
          id: c.currency.id,
          title: c.currency.title,
        });
      }
    });
  }

  prevStep() {
    this.$router.push("/claims/new-claim/select-request");
  }

  cancelNewClaim() {
    //this.$store.commit("clearNewRequest");
  }

  async nextStep() {
    let data = JSON.parse(JSON.stringify(this.data.newClaim));
    let notes = this.data.newClaim.notes;
    // delete data.notes;
    [
      "estimated_expenses",
      "estimated_loss_amount",
      "reserve_expenses",
      "reserve_indemnization",
    ].forEach((key) => {
      if (data[key])
        data[key] = parseFloat(
          String(data[key])
            .replace(/\./g, "")
            .replace(/,/g, ".")
        );
    });
    data.subscriptorId = this.$store.state.user.id;
    data.requestId = this.$store.state.newClaim.request;
    if (data.status_client === "") {
      (this.$root as any).notify("Complete el estado cedente", "error");
      return;
    }
    try {
      const request: any = await (this.$root as any)._post("claims", data);
      if (request.status !== undefined) {
        (this.$root as any).notify(request.error, "error");
      } else {
        (this.$root as any).notify("Siniestro creado con éxito!", "success");
        setTimeout(() => this.$store.commit("clearNewClaim"), 3000);
      }
    } catch (e) {
      (this.$root as any).notify(e.message, "error");
    }
  }
}
